module.exports = __webpack_public_path__ + "img/applets4.3c73720b.png";